import { render, staticRenderFns } from "./valid.vue?vue&type=template&id=530731ea&"
import script from "./valid.vue?vue&type=script&lang=js&"
export * from "./valid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports